
    import * as React from 'react';

    const Share20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Share_20_svg__Icons/Share/20" stroke="none" strokeWidth={1} fillRule="evenodd"><g id="Share_20_svg__Icons/Share/16-Copy" transform="translate(4.000000, 1.000000)" fillRule="nonzero"><polygon id="Share_20_svg__Path" points="6.45456865 1.88157895 6.45456865 13 5.54543135 13 5.54543135 1.88157895 0.606091527 7.45754917 0 6.77333864 6 0 12 6.77333864 11.3939085 7.45754917" /><path d="M1,17 L11,17 L11,10 L12,10 L12,18 L11,18 L1,18 L0,18 L0,10 L1,10 L1,17 Z" id="Share_20_svg__Combined-Shape" /></g></g></svg>
        </div>
      );
    };

    Share20.displayName = 'Share20';

    export default Share20;
  